import { useState, useRef } from "react";
import {
  AppBar as MuiAppBar,
  Avatar,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Toolbar,
  Button
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import { googleLogout } from "@react-oauth/google";
import GoogleAutocomplete from "./GoogleAutocomplete";

const CustomAppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

export default function AppBar(props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  const signOut = () => {
    props.setProfile(null);
    googleLogout();
  };
  const obieLogo = process.env.PUBLIC_URL + "/logo-white.svg";

  return (
    <CustomAppBar>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={props.toggleDrawer}
          edge="start"
        >
          <MenuIcon />
        </IconButton>
        <div style={{ width: 240, marginLeft: 13 }}>
          <img alt="obie-logo" src={obieLogo} style={{ height: 24 }} />
        </div>
        <GoogleAutocomplete
          style={{
            position: "fixed",
            minWidth: "275px",
            width: "25%",
            left: "50%",
            transform: "translate(-50%, 0)",
          }}
          {...props}
        />
        <div style={{ position: "fixed", right: "24px" }}>
          <Button
            variant="filled"
            size="small"
            to="/search"
            component={Link}
          >
            Search
          </Button>
          <IconButton ref={anchorRef} onClick={handleToggle}>
            <Avatar alt={props.profile.name} src={props.profile.picture} />
          </IconButton>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open}>
                      <MenuItem onClick={signOut}>Sign out</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Toolbar>
    </CustomAppBar>
  );
}
